$(document).ready(function() {
    if ($('.type-detail').length > 0) {
        $('.type-detail .p-detail-info a[href*="/znacka/"]').insertAfter(".p-detail-inner-header .p-code");
        $('.p-short-description, .basic-description').each(function() {
            $(this).find('p').each(function() {
                var $p = $(this);
                var content = $p.html().replace(/&nbsp;/g, '').trim();
                if (content === '') {
                    var $prevEmpty = $p.prev('p').filter(function() {
                        return $(this).html().replace(/&nbsp;/g, '').trim() === '';
                    });
                    if ($prevEmpty.length > 0) {
                        $p.hide();
                    } else {
                        $p.show();
                    }
                }
            });
        });
    }
    if ($('.type-post').length > 0) {
        $('main').find('[style],[face],[size],[color]').removeAttr('style face size color');
    }
});